import script from "./DragHandle.vue?vue&type=script&setup=true&lang=js"
export * from "./DragHandle.vue?vue&type=script&setup=true&lang=js"

import "./DragHandle.vue?vue&type=style&index=0&id=ad507120&scoped=true&lang=css"
import "./DragHandle.vue?vue&type=style&index=1&id=ad507120&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad507120"]])

export default __exports__